module.exports = __webpack_public_path__ + "img/041.bac28263.png";